import React from 'react';
import { Link } from 'react-router-dom';
import './css/sidebar.css';

export default function Sidebar() {
  return <nav className="sidebar" aria-label="Network shortcuts">
    <Link to="/stats">Chain dashboards</Link>
    <Link to="/Services">All validators</Link>
  </nav>;
}